"use strict";

exports.__esModule = true;
exports.PLUGIN_PRIORITY = exports.PLUGIN_KEY = exports.ColumnSummary = void 0;
var _columnSummary = require("./columnSummary");
exports.PLUGIN_KEY = _columnSummary.PLUGIN_KEY;
exports.PLUGIN_PRIORITY = _columnSummary.PLUGIN_PRIORITY;
exports.ColumnSummary = _columnSummary.ColumnSummary;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/plugins/columnSummary/index.js
// module id = 1275
// module chunks = 0